import { useState, useEffect, useCallback } from 'react'
import { useIsMobile } from './useMediaQuery'

const SIDEBAR_COLLAPSED_KEY = 'sidebar-collapsed'

export function useSidebarState() {
  const isMobile = useIsMobile()

  // Desktop: collapsed state (icon-only sidebar)
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false
    try {
      return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true'
    } catch {
      return false
    }
  })

  // Mobile: open state (overlay sidebar)
  const [isOpen, setIsOpen] = useState(false)

  // Persist collapsed state
  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(isCollapsed))
    } catch {
      // Ignore storage errors
    }
  }, [isCollapsed])

  // Auto-close mobile sidebar when switching from mobile to desktop
  useEffect(() => {
    if (!isMobile && isOpen) {
      setIsOpen(false)
    }
  }, [isMobile, isOpen])

  // Toggle collapsed state (desktop)
  const toggleCollapsed = useCallback(() => {
    setIsCollapsed((prev) => !prev)
  }, [])

  // Toggle open state (mobile)
  const toggleOpen = useCallback(() => {
    setIsOpen((prev) => !prev)
  }, [])

  // Open mobile sidebar
  const openSidebar = useCallback(() => {
    setIsOpen(true)
  }, [])

  // Close mobile sidebar
  const closeSidebar = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isMobile,
    isCollapsed,
    isOpen,
    toggleCollapsed,
    toggleOpen,
    openSidebar,
    closeSidebar,
    setIsCollapsed,
  }
}
